<template>
	<dropdown :disabled="noItems" :label="label">
		<div v-if="showSearch" class="dropdown-item">
			<div class="field">
				<div class="control has-icons-left">
					<input
						v-model="searchText"
						class="input is-small"
						type="search"
						placeholder="Filter"
					/>
					<span class="icon is-left">
						<i class="fas fa-search"></i>
					</span>
				</div>
			</div>
		</div>
		<div v-if="isFiltered" class="dropdown-item">
			<b-checkbox
				:value="!selected.length"
				:class="{ 'show-all-items': !selected.length }"
				@change.native="(e) => clear(e)"
				>All {{ type }}s</b-checkbox
			>
		</div>
		<div v-if="filtered.length > 0">
			<div v-for="item in filtered" :key="item.id" class="dropdown-item">
				<b-checkbox
					v-model="selected"
					:native-value="item.id"
					@input="update"
					>{{ item.name }}</b-checkbox
				>
			</div>
		</div>
		<div v-if="noMatch" class="dropdown-item">
			<p>No match found for your filter</p>
		</div>
	</dropdown>
</template>

<script>
import Dropdown from "./AppDropdown";
import { find, orderBy } from "lodash";

export default {
	components: {
		Dropdown
	},
	props: {
		items: {
			type: Array,
			default: () => []
		},
		sortBy: {
			type: Array,
			default: () => ["name"]
		},
		type: {
			type: String,
			default: () => "item"
		}
	},
	data() {
		return {
			searchText: "",
			selected: []
		};
	},
	computed: {
		label() {
			const length = this.selected.length;
			return length
				? `${length} ${this.type}${length === 1 ? "" : "s"} `
				: `All ${this.type}s`;
		},
		filtered() {
			let items = this.items;
			const search = this.searchText.toLowerCase();

			if (search) {
				items = items.filter((group) =>
					group.name.toLowerCase().includes(search)
				);
			}
			return orderBy(items, this.sortBy);
		},
		isFiltered() {
			return !(this.searchText !== "");
		},
		showSearch() {
			return this.items.length > 5;
		},
		noItems() {
			return !this.items.length > 0;
		},
		noMatch() {
			return !this.filtered.length > 0;
		}
	},
	watch: {
		items() {
			this.searchText = "";
		}
	},
	methods: {
		clear(e) {
			const checked = e.target.checked;
			if (checked) {
				this.selected = [];
			}
			this.$emit("update", this.selected);
		},
		update() {
			this.$emit("update", this.selected);
		}
	}
};
</script>

<style scoped>
.show-all-items {
	pointer-events: none;
}
.dropdown >>> .dropdown-menu {
	z-index: 3;
	width: 24rem;
	display: none;
}
.dropdown.is-active >>> .dropdown-menu {
	display: block;
}
.dropdown >>> .dropdown-content {
	max-height: 213px;
	overflow-y: auto;
}
</style>
